<div class="w-full sm:flex sm:justify-between sm:items-center md:py-4 px-4 lg:px-8 py-2.5 sm:py-1.5">
    <div class="w-full inline-block">
        <img  
        class="w-12 h-12 float-start me-3" 
        src="https://cdn-icons-png.flaticon.com/512/9187/9187604.png">
        <h4 class="text-lg font-semibold">{{ userName }}</h4>
        <p class="text-[13px] text-[#96A0B5]">{{ userAddress }}</p>
    </div>
    <div class=" inline-block">
        <div class="flex justify-between items-center bg-[#F4F6F9] px-3 py-2 rounded-full mt-1">
            <span class="text-[#25282D] font-medium text-[13px]">Status</span>
            <div class="ms-10">
                <app-toggle-switch
                    [checked]="isActive"
                    (toggleChange)="handleToggle($event)"
                ></app-toggle-switch>
            </div>
        </div>
    </div>
</div><hr>
